import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseLayer from "../core/BaseLayer";
import HeatMapModels from "./models";

var HeatMapLayer = /*#__PURE__*/function (_BaseLayer) {
  _inherits(HeatMapLayer, _BaseLayer);

  var _super = _createSuper(HeatMapLayer);

  function HeatMapLayer() {
    var _this;

    _classCallCheck(this, HeatMapLayer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "type", 'HeatMapLayer');

    return _this;
  }

  _createClass(HeatMapLayer, [{
    key: "buildModels",
    value: function buildModels() {
      var _this2 = this;

      var shape = this.getModelType();
      this.layerModel = new HeatMapModels[shape](this);
      this.layerModel.initModels(function (models) {
        _this2.dispatchModelLoad(models);
      });
    }
  }, {
    key: "rebuildModels",
    value: function rebuildModels() {
      var _this3 = this;

      this.layerModel.buildModels(function (models) {
        _this3.dispatchModelLoad(models);
      });
    }
  }, {
    key: "renderModels",
    value: function renderModels() {
      var _this4 = this;

      var shape = this.getModelType();

      if (shape === 'heatmap') {
        if (this.layerModel) {
          this.layerModel.render(); // 独立的渲染流程
        }

        return this;
      }

      if (this.layerModelNeedUpdate) {
        this.layerModel.buildModels(function (models) {
          return _this4.models = models;
        });
        this.layerModelNeedUpdate = false;
      }

      this.models.forEach(function (model) {
        return model.draw({
          uniforms: _this4.layerModel.getUninforms()
        });
      });
      return this;
    }
  }, {
    key: "updateModelData",
    value: function updateModelData(data) {
      if (data.attributes && data.elements) {
        this.models[0].updateAttributesAndElements(data.attributes, data.elements);
      } else {
        console.warn('data error');
      }
    }
  }, {
    key: "getModelType",
    value: function getModelType() {
      var _shapeAttribute$scale;

      var shapeAttribute = this.styleAttributeService.getLayerStyleAttribute('shape');

      var _this$getLayerConfig = this.getLayerConfig(),
          shape3d = _this$getLayerConfig.shape3d;

      var source = this.getSource();
      var sourceType = source.data.type;
      var shape = (shapeAttribute === null || shapeAttribute === void 0 ? void 0 : (_shapeAttribute$scale = shapeAttribute.scale) === null || _shapeAttribute$scale === void 0 ? void 0 : _shapeAttribute$scale.field) || 'heatmap';

      if (shape === 'heatmap' || shape === 'heatmap3d') {
        return 'heatmap';
      }

      if (sourceType === 'hexagon') {
        return (shape3d === null || shape3d === void 0 ? void 0 : shape3d.indexOf(shape)) === -1 ? 'hexagon' : 'grid3d';
      }

      if (sourceType === 'grid') {
        return (shape3d === null || shape3d === void 0 ? void 0 : shape3d.indexOf(shape)) === -1 ? 'grid' : 'grid3d';
      }

      return 'heatmap';
    }
  }]);

  return HeatMapLayer;
}(BaseLayer);

export { HeatMapLayer as default };